import { takeEvery } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { fetchApiAuth } from '../utils/api';

import {
    resourcesSuccess,
    resourcesFailure,

    categoriesSuccess,
    categoriesFailure,

    ownResourcesSuccess,
    ownResourcesFailure,

    createResourceSuccess,
    createResourceFailure,

    updateResourceSuccess,
    updateResourceFailure,

    deleteResourceSuccess,
    deleteResourceFailure
} from './resourcesActions';

const {
    RESOURCES_REQUEST,
    CATEGORIES_REQUEST,
    REGISTER_RESOURCE_VIEW_REQUEST,
    OWN_RESOURCES_REQUEST,
    CREATE_RESOURCE_REQUEST,
    UPDATE_RESOURCE_REQUEST,
    DELETE_RESOURCE_REQUEST
} = require('./resourcesActions').constants;

function* fetchResources() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'get',
            url: 'resources'
        });

        yield put(resourcesSuccess(response));
    } catch (e) {
        console.log('res', e.response);
        yield put(resourcesFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

function* fetchCategoriesResources() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'get',
            url: 'categories'
        });

        yield put(categoriesSuccess(response));
    } catch (e) {
        console.log('res', e.response);
        yield put(categoriesFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

function* registerResourceView(action) {
    try {
        yield call(fetchApiAuth, {
            method: 'post',
            url: 'resource/register-resource-download',
            body: action.payload
        });
    } catch (e) {
        console.log('res', e.response);
    }
}

function* fetchOwnResources() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'get',
            url: 'resources',
            params: { owned: true }
        });

        yield put(ownResourcesSuccess(response));
    } catch (e) {
        console.log('res', e.response);
        yield put(ownResourcesFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

function* createResource(actions) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'post',
            url: 'resources',
            body: actions.payload
        });

        yield put(createResourceSuccess(response));
    } catch (e) {
        console.log('res', e.response);
        yield put(createResourceFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

function* updateResource(actions) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'put',
            url: `resources/${actions.payload.id}`,
            body: actions.payload
        });

        yield put(updateResourceSuccess(response));
    } catch (e) {
        console.log('res', e.response);
        yield put(updateResourceFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

function* deleteResource(actions) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'delete',
            url: `resources/${actions.payload.id}`
        });

        yield put(deleteResourceSuccess(response));
    } catch (e) {
        console.log('res', e.response);
        yield put(deleteResourceFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* resourcesSaga() {
    yield* [
        takeEvery(RESOURCES_REQUEST, fetchResources),
        takeEvery(CATEGORIES_REQUEST, fetchCategoriesResources),
        takeEvery(REGISTER_RESOURCE_VIEW_REQUEST, registerResourceView),
        takeEvery(OWN_RESOURCES_REQUEST, fetchOwnResources),
        takeEvery(CREATE_RESOURCE_REQUEST, createResource),
        takeEvery(UPDATE_RESOURCE_REQUEST, updateResource),
        takeEvery(DELETE_RESOURCE_REQUEST, deleteResource)
    ];
}



/** WEBPACK FOOTER **
 ** ./src/core/resources/resourcesSaga.js
 **/